






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class PageTitle extends Vue {
  name: "PageTitle";

  @Prop({ required: true })
  public title!: string;
}
